export default {
    CHANGE_TIME(state, reqTime) {
        state.time = reqTime
    },
    CHANGE_REALTIME(state, reqTime) {
        state.realTime = reqTime
    },
    CHANGE_CITY(state, reqCity) {
        state.city = reqCity
    },
    CHANGE_MONTH(state, reqMonth) {
        state.month = reqMonth
    },
    CHANGE_LOADING(state, { name, index, status }) {
        state.loadding[name][index] = status;
        state.loadding = JSON.parse(JSON.stringify(state.loadding));
    },
    CHANGE_NAVIGATION(state, name) {
        state.navigation.name = name
    }
}